/* assets/bb-cart.js — Bloom-Bloom cart drawer (MOTSOM THEME 2026)
   Ιστορικο αποφασεων 22/09–09/10/2026: βλ. fixes-2026-10-17/original-live/assets/bb-cart.js (header).
   17/10/2026 AUDIT: noDrawer=false (το ΠΡΟΣΘΗΚΗ ξανανοιγει το συρταρι), toast 2,5 s, μια δονηση,
   ctaHTML οπως το bb-cart-extras, ΟΧΙ δονηση σε καθε πατημα, CP MODE (συρταρι = σελιδα /cart). */
(function () {
  'use strict';
  if (window.__bbCart) { return; }
  window.__bbCart = true;

  var MQ = '(max-width: 768.98px)';
  var BAG_FALLBACK = '54854761120071';
  var TRASH = '<svg width="20" height="20" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/><path d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5zm2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5z" fill="currentColor"/></svg>';

  function isMobile() { return !!(window.matchMedia && matchMedia(MQ).matches); }
  /* (20) 09/10/2026 — αποφαση ιδιοκτητη: το ΠΡΟΣΘΗΚΗ δεν ανοιγει ΠΟΤΕ το συρταρι — ουτε
     στο desktop. Παντου: μηνυμα «Προστεθηκε…» + πλωτο κουμπι καλαθιου (παει στο /cart).
     17/10/2026 — AUDIT FIX: ΓΥΡΙΣΕ ΠΙΣΩ. Απο 13/10 (publish) το ποσοστο ATC→checkout επεσε
     απο 63% σε 52% και το CR απο 2,8% σε 1,6%. Με «return true» ο πελατης μετα το ΠΡΟΣΘΗΚΗ
     εβλεπε μονο ενα μηνυμα 1 δευτερολεπτου και επρεπε να βρει μονος του το πλωτο κουμπι
     και να περασει απο ολοκληρη σελιδα /cart για να φτασει στο ΤΑΜΕΙΟ (2 κλικ + 1 reload).
     Τωρα: το συρταρι ανοιγει ΑΜΕΣΩΣ (optimistic) με το προϊον μεσα και το ΤΑΜΕΙΟ μπροστα του.
     Αν ποτε ξαναχρειαστει το παλιο: return true. */
  function noDrawer() { return false; }
  function drawer() { return document.getElementById('cart-drawer'); }
  /* 17/10/2026 CP MODE: το συρταρι ρενταρει τη σελιδα /cart (snippets/cart-drawer.liquid με data-bb-cp,
     snippets/bb-cp.liquid). Τοτε ΔΕΝ τρεχει το optimistic stepper/σακουλα/ghost απο εδω — τις αλλαγες
     τις κανει το cart-items.js του theme (οπως στη σελιδα /cart) και το ΠΡΟΣΘΗΚΗ ανοιγει το συρταρι
     με «Προστιθεται…» μεχρι να απαντησει ο server. Βλ. το μπλοκ CP MODE πιο κατω. */
  function cpMode(d) { d = d || drawer(); return !!(d && d.hasAttribute('data-bb-cp')); }
  function attr(name, fallback) {
    var d = drawer();
    var v = d && d.getAttribute(name);
    return (v === null || v === undefined || v === '') ? fallback : v;
  }
  function sectionIdOf(d) {
    try {
      var s = d && d.closest('.shopify-section');
      return s && s.id ? s.id.replace('shopify-section-', '') : '';
    } catch (e) { return ''; }
  }
  function routes() {
    var r = (window.theme && window.theme.routes) || {};
    return {
      cart: r.cart || '/cart',
      add: r.cartAdd || '/cart/add',
      change: r.cartChange || '/cart/change'
    };
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Εκτελεση ΜΕΤΑ τη ζωγραφικη της οθονης — δεν καθυστερει την αντιδραση στο πατημα */
  function afterPaint(fn) {
    var done = false;
    function go() { if (done) { return; } done = true; fn(); }
    if (window.requestAnimationFrame) { requestAnimationFrame(function () { setTimeout(go, 0); }); }
    setTimeout(go, 120); /* διχτυ: σε κρυφη καρτελα το rAF δεν τρεχει */
  }
  function replay(el, a, b) {
    if (!el) { return; }
    if (el.classList.contains(a)) { el.classList.remove(a); el.classList.add(b); } else { el.classList.remove(b); el.classList.add(a); }
  }

  /* =========================================================================
     ΧΡΗΜΑΤΑ — οπως το | money του Liquid (shop.money_format)
     ========================================================================= */
  function formatMoney(cents) {
    var format = attr('data-bb-money', '€{{amount_with_comma_separator}}');
    cents = Math.round(Number(cents) || 0);
    var neg = cents < 0;
    if (neg) { cents = -cents; }
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(format);
    var key = m ? m[1] : 'amount';
    function num(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    var v;
    switch (key) {
      case 'amount_no_decimals': v = num(0, ',', '.'); break;
      case 'amount_with_comma_separator': v = num(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = num(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = num(2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = num(0, ' ', ','); break;
      case 'amount_with_space_separator': v = num(2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = num(2, ' ', '.'); break;
      default: v = num(2, ',', '.');
    }
    return (neg ? '-' : '') + format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* =========================================================================
     ΑΝΑΓΝΩΣΗ ΤΟΥ DRAWER + ΥΠΟΛΟΓΙΣΜΟΙ (ιδιοι με το Liquid του bb-cart-extras)
     ========================================================================= */
  function bagId() { return attr('data-bb-bag', BAG_FALLBACK); }
  function bagPrice() { return parseInt(attr('data-bb-bag-price', '100'), 10) || 100; }
  function threshold() { return parseInt(attr('data-bb-th', '6000'), 10) || 6000; }
  function countryName() { return attr('data-bb-country', ''); }

  function rowQty(row) {
    var i = row.querySelector('.qty-input__input');
    return i ? Math.max(0, parseInt(i.value, 10) || 0) : 0;
  }
  function rowUnit(row) { return parseInt(row.getAttribute('data-bb-unit'), 10) || 0; }
  function rowOrig(row) { return parseInt(row.getAttribute('data-bb-orig'), 10) || rowUnit(row); }

  function computeTotals(d) {
    var t = { base: 0, orig: 0, bagQty: 0, bagTotal: 0, total: 0, prod: 0, count: 0 };
    var rows = d.querySelectorAll('cart-items .cart-item');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.classList.contains('bb-removed')) { continue; }
      var q = rowQty(row);
      if (!q) { continue; }
      t.count += q;
      if (row.getAttribute('data-variant-id') === bagId()) {
        t.bagQty += q; t.bagTotal += rowUnit(row) * q;
      } else {
        t.prod += 1; t.base += rowUnit(row) * q; t.orig += rowOrig(row) * q;
      }
    }
    if (t.orig < t.base) { t.orig = t.base; }
    t.total = t.base + t.bagTotal;
    return t;
  }

  function shippingHTML(base) {
    var th = threshold();
    var country = countryName();
    var where = (country ? country + ', ' : '') + 'από ' + formatMoney(th);
    if (base >= th) {
      return '<div class="bb-sh is-ok" data-bb-zone="shipping"><div class="bb-sh-top"><span class="bb-sh-ttl">ΔΩΡΕΑΝ ΜΕΤΑΦΟΡΙΚΑ</span><em class="bb-sh-sum">είσαι στα <b>' + formatMoney(base) + '</b></em></div><div class="bb-ax"><i class="bb-fill" style="width:100%"></i></div><p class="bb-sh-msg"><b>Κέρδισες δωρεάν μεταφορικά</b> · ' + where + '</p></div>';
    }
    var gap = Math.max(0, th - base);
    var pct = th > 0 ? Math.min(100, Math.round(base * 10000 / th) / 100) : 0;
    return '<div class="bb-sh is-wait" data-bb-zone="shipping"><div class="bb-sh-top"><span class="bb-sh-ttl">ΔΩΡΕΑΝ ΜΕΤΑΦΟΡΙΚΑ</span><em class="bb-sh-sum">είσαι στα <b>' + formatMoney(base) + '</b></em></div><div class="bb-ax"><i class="bb-fill" style="width:' + pct + '%"></i></div><p class="bb-sh-msg"><b>Λείπουν ' + formatMoney(gap) + '</b> για δωρεάν μεταφορικά · ' + where + '</p></div>';
  }

  /* (16) ΜΙΑ γραμμη «ΣΥΝΟΛΟ»· η αρχικη τιμη (προϊοντα + σακουλες) τσιμπημενη διπλα οταν υπαρχει οφελος.
     Με σακουλα: πανω απο το ΣΥΝΟΛΟ η γραμμη «Σακουλα δωρου × n … ποσο». */
  function totalsHTML(t) {
    return (t.bagQty > 0 ? '<div class="bb-rw">Σακούλα δώρου × ' + t.bagQty + ' <b>' + formatMoney(t.bagTotal) + '</b></div>' : '') + '<div class="bb-tot"><span>ΣΥΝΟΛΟ</span><span class="bb-vals">' + (t.orig > t.base ? '<s class="bb-was">' + formatMoney(t.orig + t.bagTotal) + '</s>' : '') + '<b>' + formatMoney(t.total) + '</b></span></div>';
  }
  /* 17/10/2026 AUDIT FIX: ιδιο HTML με το part 'cta' του snippets/bb-cart-extras.liquid
     (ΣΥΝΕΧΙΣΤΕ στο desktop, ΚΑΛΑΘΙ στο κινητο). Πριν εβγαζε μονο το παλιο κουμπι, που το CSS
     του κινητου το κρυβει — στο ghost state (0,5-1 s) ο πελατης εβλεπε ΜΟΝΟ ενα ανενεργο ΤΑΜΕΙΟ. */
  function ctaHTML(disabled) {
    return '<div class="bb-cta"><button type="button" class="bb-c2 bb-c2--d js-close-drawer">ΣΥΝΕΧΙΣΤΕ</button><a class="bb-c2 bb-c2--m" href="' + esc(routes().cart) + '" data-no-instant>ΚΑΛΑΘΙ</a><style>#cart-drawer .bb-c2--m{display:none}@media (max-width:768.98px){#cart-drawer .bb-c2--d{display:none}#cart-drawer .bb-c2--m{display:flex}}</style><button type="submit" class="bb-c1" name="checkout" form="cart-drawer-form"' + (disabled ? ' disabled' : '') + '>ΤΑΜΕΙΟ</button></div>';
  }
  /* (16) σακουλα δωρου: απλη γραμμη. Τα «προσωρινα» κομματια (bb-qt--wait, bb-lnk--wait)
     φαινονται ΜΟΝΟ μεχρι να απαντησει ο server· η απαντηση ξαναγραφει τη ζωνη με τις
     πραγματικες φορμες (το «− / +» θελει τον αριθμο γραμμης της σακουλας). */
  function bagLabel(qty) {
    return 'Σακούλα δώρου · ' + formatMoney(bagPrice()) + (qty > 0 ? ' / τεμ.' : '');
  }
  function bagWaitHTML(qty) {
    if (qty > 0) { return '<div class="bb-qt bb-qt--wait" aria-hidden="true"><span class="bb-step">−</span><span class="bb-qtn">' + qty + '</span><span class="bb-step">+</span></div>'; }
    return '<span class="bb-lnk bb-lnk--wait" aria-hidden="true">+ Προσθήκη</span>';
  }
  function bagRowHTML(t) {
    var right = t.bagQty > 0 ? bagWaitHTML(t.bagQty) : '<form class="bb-af" action="' + routes().add + '" method="post" data-bb-endpoint="' + routes().add + '.js" data-bb-kind="add"><input type="hidden" name="id" value="' + esc(bagId()) + '"><input type="hidden" name="quantity" value="1"><button type="submit" class="bb-lnk">+ Προσθήκη</button></form>';
    return '<div class="bb-fold bb-fold--bag" data-bb-zone="bag"><div class="bb-flat"><span class="bb-fold-lb">' + bagLabel(t.bagQty) + '</span>' + right + '</div></div>';
  }
  function noteFoldHTML() {
    return '<details class="bb-fold bb-fold--note" data-bb-zone="note"><summary><span class="bb-fold-lb">Μήνυμα στην παραγγελία</span><span class="bb-fold-pm" aria-hidden="true"></span></summary><div class="bb-fold-bd"><div class="bb-ms"><label class="bb-sr" for="cart-note">Μήνυμα στην παραγγελία</label><cart-note class="block"><textarea id="cart-note" name="note" form="cart-drawer-form" rows="2" placeholder="Αφήστε μας το μήνυμά σας…"></textarea></cart-note></div></div></details>';
  }

  /* (20) συνολο γραμμης + «2 × 16,00€» — ΙΔΙΟ HTML με το .bb-lp του snippets/cart-items.liquid */
  function linePriceHTML(unit, orig, q) {
    return '<span class="bb-lp-now">' + formatMoney(unit * q) + '</span>' + (orig > unit ? '<s class="bb-lp-was">' + formatMoney(orig * q) + '</s>' : '') + '<span class="bb-lp-ux">' + q + ' × ' + formatMoney(unit) + '</span>';
  }

  /* --- μια γραμμη: ποσοτητα (data-bb-qty) + συνολο γραμμης (.bb-lp, φαινεται οταν ποσοτητα > 1), ή αφαιρεση --- */
  function paintRow(row) {
    var q = rowQty(row);
    if (q === 0) { row.classList.add('bb-removed'); return; }
    row.classList.remove('bb-removed');
    var info = row.querySelector('.cart-item__info');
    if (info) {
      info.setAttribute('data-bb-qty', q);
      var lp = info.querySelector('.bb-lp');
      if (!lp) {
        lp = document.createElement('div'); lp.className = 'bb-lp'; lp.hidden = true;
        var first = info.firstElementChild;
        if (first) { first.insertAdjacentElement('afterend', lp); } else { info.appendChild(lp); }
      }
      lp.innerHTML = linePriceHTML(rowUnit(row), rowOrig(row), q);
    }
    var tot = row.querySelector('.cart-item__total .price__current');
    if (tot) { tot.textContent = formatMoney(rowUnit(row) * q); }
  }

  /* --- συνολα + μεταφορικα + σακουλα (χωρις αιτηση) ---
     ghost=true: το καλαθι ηταν αδειο και γεμιζει τωρα (ΠΡΟΣΘΗΚΗ): χτιζονται και
     τα κομματια που δεν υπαρχουν ακομα (footer, σακουλα, μηνυμα), ΤΑΜΕΙΟ ανενεργο. */
  function paintTotals(d, ghost) {
    var t = computeTotals(d);
    var empty = t.prod === 0 && t.bagQty === 0;

    var ft = d.querySelector('.bb-ft');
    if (ft) {
      if (empty) {
        ft.innerHTML = '';
        ft.classList.add('bb-ft--empty');
      } else {
        var old = ft.querySelectorAll('.bb-rw,.bb-tot');
        for (var i = 0; i < old.length; i++) { old[i].parentNode.removeChild(old[i]); }
        var cta = ft.querySelector('.bb-cta');
        if (cta) { cta.insertAdjacentHTML('beforebegin', totalsHTML(t)); } else { ft.innerHTML = totalsHTML(t) + ctaHTML(!!ghost); }
        ft.classList.remove('bb-ft--empty');
      }
    }

    var top = document.getElementById('cart-promoted-products');
    if (top) { top.innerHTML = empty ? '' : shippingHTML(t.base); }

    var bottom = document.getElementById('cart-drawer-media-promotion');
    if (bottom) {
      if (empty) {
        bottom.innerHTML = '';
      } else {
        var fold = bottom.querySelector('.bb-fold--bag');
        if (fold) {
          var lb = fold.querySelector('.bb-fold-lb');
          if (lb) { lb.textContent = bagLabel(t.bagQty); }
          var qn = fold.querySelector('.bb-qtn');
          var addForm = fold.querySelector('.bb-af[data-bb-kind="add"]');
          var qt = fold.querySelector('.bb-qt');
          if (t.bagQty > 0) {
            if (qn) { qn.textContent = t.bagQty; }
            else if (addForm && !addForm.hidden) { addForm.insertAdjacentHTML('afterend', bagWaitHTML(t.bagQty)); addForm.hidden = true; }
          } else if (qt && !qt.hidden) {
            qt.insertAdjacentHTML('afterend', bagWaitHTML(0)); qt.hidden = true;
          }
        } else if (ghost) {
          bottom.innerHTML = bagRowHTML(t);
        }
      }
    }

    if (ghost && !empty && bottom && !d.querySelector('[data-bb-zone="note"]')) {
      bottom.insertAdjacentHTML('afterend', noteFoldHTML());
    }

    var ls = d.querySelector('.bb-ls');
    if (ls) { ls.classList.toggle('bb-ls--empty', empty); }
    var ci = d.querySelector('cart-items');
    if (ci && !empty) { ci.setAttribute('data-empty', 'false'); }
    if (ci && empty && !ci.querySelector('.cart-empty')) {
      /* αδειο καλαθι ΑΜΕΣΩΣ: το template του snippets/cart-drawer.liquid */
      var tpl = document.getElementById('bb-cart-empty-tpl');
      var table = ci.querySelector('.cart-items');
      if (tpl && table) {
        table.parentNode.removeChild(table);
        ci.insertAdjacentHTML('afterbegin', tpl.innerHTML);
        ci.setAttribute('data-empty', 'true');
      }
    }
    return t;
  }

  /* =========================================================================
     ΜΠΑΡΑ «ΤΡΕΧΕΙ ΑΙΤΗΣΗ» (λεπτη, στην κορυφη του drawer)
     ========================================================================= */
  var inflight = 0;
  var busyT = null;
  function setBusy(delta) {
    inflight = Math.max(0, inflight + (delta || 0));
    /* (19) διχτυ ασφαλειας: αν μια αιτηση δεν «κλεισει» ποτε, η μπαρα σβηνει μονη της σε 15 s */
    clearTimeout(busyT); busyT = null;
    if (inflight > 0) {
      busyT = setTimeout(function () {
        busyT = null; inflight = 0;
        try { var pfs = document.querySelectorAll('product-form'); for (var i = 0; i < pfs.length; i++) { pfs[i].__bbQ = null; } } catch (x) { /* noop */ }
        setBusy(0);
        refreshFromServer();
      }, 15000);
    }
    var d = drawer();
    if (!d) { return; }
    var b = d.querySelector(':scope > .bb-busy');
    if (!b) { b = document.createElement('div'); b.className = 'bb-busy'; b.setAttribute('aria-hidden', 'true'); d.appendChild(b); }
    d.classList.toggle('bb-is-busy', inflight > 0);
  }

  /* =========================================================================
     RENDER ΤΩΝ ΖΩΝΩΝ απο μια απαντηση με sections (ιδιοι στοχοι με το
     cart-items.js του theme: <cart-items>, #cart-promoted-products,
     .cart-drawer__summary, #cart-drawer-media-promotion, #cart-icon-bubble)
     ========================================================================= */
  function pick(html, selector) {
    var tmpl = document.createElement('template');
    tmpl.innerHTML = html || '';
    var el = tmpl.content.querySelector(selector);
    return el ? el.innerHTML : '';
  }
  function renderZones(d, sections) {
    var sid = sectionIdOf(d);
    var html = sections && sections[sid];
    if (!html) { throw new Error('no section'); }
    var tmpl = document.createElement('template');
    tmpl.innerHTML = html;
    var src = tmpl.content;
    var map = [
      ['cart-items', 'cart-items'],
      ['cart-promoted-products', '#cart-promoted-products'],
      ['cart-drawer', '.cart-drawer__summary'],
      ['cart-drawer-media-promotion', '#cart-drawer-media-promotion']
    ];
    for (var i = 0; i < map.length; i++) {
      var target = document.getElementById(map[i][0]);
      if (!target) { continue; }
      var el = target.querySelector(map[i][1]) || (target.matches(map[i][1]) ? target : null);
      var fresh = src.querySelector(map[i][1]);
      if (el && fresh) {
        el.innerHTML = fresh.innerHTML;
        if (el.tagName === 'CART-ITEMS' && fresh.hasAttribute('data-empty')) { el.setAttribute('data-empty', fresh.getAttribute('data-empty')); }
      }
    }
    var freshCi = src.querySelector('cart-items');
    var empty = !!(freshCi && freshCi.getAttribute('data-empty') === 'true');
    var ls = d.querySelector('.bb-ls');
    if (ls) { ls.classList.toggle('bb-ls--empty', empty); }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) { bubble.innerHTML = pick(sections['cart-icon-bubble'], '.shopify-section'); }
    d.classList.remove('bb-ghosting');
  }

  function refreshDrawer(d) {
    try {
      d = d || drawer();
      if (!d) { return Promise.resolve(); }
      if (typeof d.refresh === 'function') { return Promise.resolve(d.refresh(true)).catch(function () {}); }
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    } catch (e) { /* noop */ }
    return Promise.resolve();
  }

  /* οτι πρεπει να επιβιωσει ενα ολοκληρο ξαναγραψιμο του drawer */
  function snapshot(d) {
    var s = { bagOpen: null, noteOpen: null, noteVal: null, listTop: 0 };
    try {
      var bag = d.querySelector('[data-bb-zone="bag"]');
      if (bag && bag.tagName === 'DETAILS') { s.bagOpen = bag.hasAttribute('open'); }
      var note = d.querySelector('[data-bb-zone="note"]');
      if (note && note.tagName === 'DETAILS') { s.noteOpen = note.hasAttribute('open'); }
      var ta = d.querySelector('#cart-note');
      if (ta) { s.noteVal = ta.value; }
      var ls = d.querySelector('.bb-ls');
      if (ls) { s.listTop = ls.scrollTop; }
    } catch (e) { /* noop */ }
    return s;
  }
  function restore(d, s) {
    try {
      var bag = d.querySelector('[data-bb-zone="bag"]');
      if (bag && bag.tagName === 'DETAILS' && s.bagOpen !== null) { bag.toggleAttribute('open', s.bagOpen); }
      var note = d.querySelector('[data-bb-zone="note"]');
      if (note && note.tagName === 'DETAILS' && s.noteOpen !== null) { note.toggleAttribute('open', s.noteOpen); }
      var ta = d.querySelector('#cart-note');
      if (ta && s.noteVal !== null && ta.value !== s.noteVal) { ta.value = s.noteVal; }
      var ls = d.querySelector('.bb-ls');
      if (ls && s.listTop) { ls.scrollTop = s.listTop; }
    } catch (e) { /* noop */ }
  }

  /* =========================================================================
     STEPPER (+ / − / καδος / πληκτρολογηση) — optimistic, με line-item key
     ========================================================================= */
  var seq = 0;
  var lastChange = {};
  /* 13/10/2026: ΟΥΡΑ αιτησεων αλλαγης. Πριν, γρηγορες αλλαγες σε διαφορετικες γραμμες εφευγαν παραλληλα και
     το Shopify μπορουσε να τις εκτελεσει με αλλη σειρα → το συρταρι εδειχνε λαθος καλαθι μεχρι το refresh.
     Τωρα η καθε αιτηση ξεκιναει αφου τελειωσει η προηγουμενη· ρενταρει μονο η τελευταια (seq). */
  var chgQ = Promise.resolve();
  function enqueue(fn) {
    var p = chgQ.then(fn, fn);
    chgQ = p.then(function () {}, function () {});
    return p;
  }

  function lineError(d, row, msg) {
    try {
      var box = row && row.querySelector('.cart-item__error');
      if (!box) { box = d.querySelector('#cart-errors'); }
      if (!box) { return; }
      box.textContent = msg || ((window.theme && theme.strings && theme.strings.cartError) || 'Κάτι πήγε στραβά. Δοκίμασε ξανά.');
      box.hidden = false;
    } catch (e) { /* noop */ }
  }

  function changeLine(d, row, qty) {
    var key = row.getAttribute('data-bb-key');
    var line = row.querySelector('.qty-input__input');
    var lineIndex = line ? parseInt(line.getAttribute('data-index'), 10) : NaN;
    var variantId = row.getAttribute('data-variant-id');
    var body = { quantity: qty, sections: [sectionIdOf(d), 'cart-icon-bubble'], sections_url: window.location.pathname };
    if (key) { body.id = key; } else if (!isNaN(lineIndex)) { body.line = lineIndex; } else { return; }

    var mySeq = ++seq;
    var oldQty = lastChange[variantId];
    lastChange[variantId] = qty;
    setBusy(1);
    var snap = snapshot(d);

    enqueue(function () {
      return fetch(routes().change + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
    }).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; }, function () { return { ok: false, data: {} }; });
    }).then(function (r) {
      setBusy(-1);
      if (mySeq !== seq) { return; } /* ηρθε νεοτερη αιτηση: ρενταρει εκεινη */
      var live = drawer();
      if (!live) { return; }
      if (!r.ok) {
        var msg = r.data && (r.data.description || r.data.message);
        return refreshDrawer(live).then(function () { lineError(drawer(), null, typeof msg === 'string' ? msg : ''); });
      }
      renderZones(live, r.data.sections);
      restore(live, snap);
      try {
        var ci = live.querySelector('cart-items');
        (ci || live).dispatchEvent(new CustomEvent('on:line-item:change', {
          bubbles: true,
          detail: { variantId: Number(variantId), oldQuantity: oldQty, newQuantity: qty }
        }));
      } catch (e) { /* noop */ }
    }).catch(function () {
      setBusy(-1);
      if (mySeq !== seq) { return; }
      var live = drawer();
      if (live) { refreshDrawer(live).then(function () { lineError(drawer(), null, ''); }); }
    });
  }

  /* change στο input ποσοτητας (το quantity-input του theme το στελνει και για + / −) */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('#cart-drawer cart-items .qty-input__input')) { return; }
    var d = drawer();
    if (cpMode(d)) { return; } /* CP MODE: ο stepper του theme (cart-items.js) */
    var row = t.closest('.cart-item');
    if (!d || !row || row.classList.contains('bb-ghost')) { e.stopPropagation(); return; }
    e.stopPropagation(); /* ΟΧΙ ο stepper του theme (cart-items.js) */
    var q = Math.max(0, parseInt(t.value, 10) || 0);
    t.value = q;
    paintRow(row);
    paintTotals(d, false);
    changeLine(d, row, q);
  }, true);

  /* καδος */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var btn = t.closest('#cart-drawer cart-items .js-remove-item');
    if (!btn) { return; }
    if (cpMode()) { return; } /* CP MODE: ο καδος του theme (cart-items.js) */
    e.preventDefault();
    e.stopPropagation(); /* ΟΧΙ το handleClick του theme */
    var d = drawer();
    var row = btn.closest('.cart-item');
    if (!d || !row || row.classList.contains('bb-ghost')) { return; }
    var input = row.querySelector('.qty-input__input');
    if (input) { input.value = 0; }
    paintRow(row);
    paintTotals(d, false);
    changeLine(d, row, 0);
  }, true);

  /* =========================================================================
     ΣΑΚΟΥΛΑ ΔΩΡΟΥ (.bb-af): optimistic + ΜΙΑ αιτηση με sections -> ολο το drawer
     ========================================================================= */
  function payloadFrom(form) {
    var data = {};
    var inputs = form.querySelectorAll('input[name]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.name === 'return_to') { continue; }
      var num = parseInt(input.value, 10);
      data[input.name] = isNaN(num) ? input.value : num;
      /* 13/10/2026: το /cart/change.js θελει το id ως κειμενο (variant id ή line-item key) — ως αριθμο το απορριπτει (400) */
      if (input.name === 'id' && form.getAttribute('data-bb-kind') === 'change') { data.id = String(input.value); }
    }
    return data;
  }
  var bagBusy = false;
  document.addEventListener('submit', function (event) {
    var form = event.target;
    try {
      if (!form || !form.classList || !form.classList.contains('bb-af')) { return; }
      if (!window.fetch) { return; }
      var endpoint = form.getAttribute('data-bb-endpoint');
      if (!endpoint) { return; }
      event.preventDefault();
      if (bagBusy) { return; }
      bagBusy = true;

      var d = drawer();
      var sectionId = sectionIdOf(d);
      var canRender = !!(d && sectionId && typeof d.renderContents === 'function');
      var body = payloadFrom(form);
      if (canRender) {
        body.sections = [sectionId, 'cart-icon-bubble'];
        body.sections_url = window.location.pathname;
      }

      /* optimistic: η κρυφη γραμμη της σακουλας μεσα στο <cart-items> */
      if (d) {
        var kind = form.getAttribute('data-bb-kind');
        var bagRow = d.querySelector('cart-items .cart-item[data-variant-id="' + bagId() + '"]');
        if (kind === 'change' && bagRow) {
          var bi = bagRow.querySelector('.qty-input__input');
          if (bi) { bi.value = Math.max(0, parseInt(body.quantity, 10) || 0); }
          paintRow(bagRow);
        } else if (kind === 'add') {
          var tb = d.querySelector('cart-items .cart-items tbody');
          if (tb && !bagRow) {
            tb.insertAdjacentHTML('beforeend', '<tr class="cart-item bb-ghost" data-variant-id="' + esc(bagId()) + '" data-bb-unit="' + bagPrice() + '" data-bb-orig="' + bagPrice() + '"><td class="cart-item__qty"><input type="hidden" class="qty-input__input" value="' + (parseInt(body.quantity, 10) || 1) + '"></td></tr>');
          } else if (bagRow) {
            var bi2 = bagRow.querySelector('.qty-input__input');
            if (bi2) { bi2.value = (parseInt(bi2.value, 10) || 0) + (parseInt(body.quantity, 10) || 1); }
            paintRow(bagRow);
          }
        }
        paintTotals(d, false);
        var buttons = form.querySelectorAll('button');
        for (var i = 0; i < buttons.length; i++) { buttons[i].disabled = true; }
      }
      var snap = d ? snapshot(d) : null;
      setBusy(1);

      ++seq; /* 13/10/2026: μια αλλαγη γραμμης που περιμενει στην ουρα να μην ξαναγραψει το συρταρι μετα απο αυτη */
      enqueue(function () {
        return fetch(endpoint, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      }).then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      }).then(function (r) {
        var live = drawer();
        var sections = r.ok && r.data && r.data.sections;
        if (!live || !canRender || !sections || !sections[sectionId] || !sections['cart-icon-bubble']) {
          return refreshDrawer(live);
        }
        return Promise.resolve(live.renderContents({ sections: sections }, false)).then(function () {
          if (snap) { restore(live, snap); }
        });
      }).catch(function () {
        return refreshDrawer(drawer());
      }).then(function () {
        setBusy(-1);
        bagBusy = false;
      });
    } catch (e) {
      bagBusy = false;
      try { form.submit(); } catch (e2) { /* noop */ }
    }
  });

  /* =========================================================================
     ΚΛΕΙΔΩΜΑ ΤΗΣ ΣΕΛΙΔΑΣ οσο το drawer ειναι ανοιχτο (κλαση bb-cart-open)
     ========================================================================= */
  var LOCK_CLS = 'bb-cart-open';
  var savedY = 0;
  var locked = false;
  function lockPage() {
    try {
      if (locked) { return; }
      locked = true;
      savedY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.top = (-savedY) + 'px';
      document.documentElement.classList.add(LOCK_CLS);
      document.body.classList.add(LOCK_CLS);
    } catch (e) { /* noop */ }
  }
  function unlockPage() {
    try {
      if (!locked) { return; }
      locked = false;
      var wasFixed = window.getComputedStyle(document.body).position === 'fixed';
      document.documentElement.classList.remove(LOCK_CLS);
      document.body.classList.remove(LOCK_CLS);
      document.body.style.top = '';
      if (wasFixed) { window.scrollTo(0, savedY); }
    } catch (e) { /* noop */ }
  }
  function watchDrawer(d) {
    try {
      if (!d || d.__bbLockObs || !('MutationObserver' in window)) { return; }
      d.__bbLockObs = true;
      new MutationObserver(function () {
        if (d.hasAttribute('open')) { lockPage(); } else { unlockPage(); }
      }).observe(d, { attributes: true, attributeFilter: ['open'] });
    } catch (e) { /* noop */ }
  }
  document.addEventListener('on:cart-drawer:before-open', function (evt) {
    var d = (evt && evt.target && evt.target.id === 'cart-drawer') ? evt.target : drawer();
    watchDrawer(d);
    lockPage();
  });
  if (!('MutationObserver' in window)) {
    document.addEventListener('on:cart-drawer:before-close', function () { unlockPage(); });
  }
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { unlockPage(); });
  }

  /* =========================================================================
     ΑΝΟΙΓΜΑ / ΑΡΙΘΜΟΣ ΣΤΟ ΕΙΚΟΝΙΔΙΟ / ΠΡΟΣΘΗΚΗ
     ========================================================================= */
  function openDrawer() {
    try {
      var d = drawer();
      if (!d || d.hasAttribute('open')) { return; }
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    } catch (x) { /* noop */ }
  }

  var shownCount = null;
  function wrap() { return document.getElementById('cart-icon-bubble'); }
  function setCount(n, pop) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < 0) { return; }
    var w = wrap();
    if (!w) { return; }
    var box = w.querySelector('.header__cart-count');
    if (n === 0) { if (box) { box.remove(); } shownCount = 0; syncFloat(0, false); return; }
    if (!box) {
      box = document.createElement('div');
      box.className = 'header__cart-count absolute bg-theme-text text-theme-bg text-center';
      box.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      w.appendChild(box);
    }
    var num = box.querySelector('span[aria-hidden]') || box.firstElementChild;
    var sr = box.querySelector('.visually-hidden');
    if (num && num.textContent.trim() !== String(n)) { num.textContent = n; if (pop) { replay(box, 'bb-count-pop', 'bb-count-pop2'); } }
    if (sr) { sr.textContent = n + (n === 1 ? ' προϊόν' : ' προϊόντα'); }
    shownCount = n;
    syncFloat(n, pop);
  }
  function currentCount() {
    var w = wrap();
    var num = w && w.querySelector('.header__cart-count span[aria-hidden]');
    return num ? parseInt(num.textContent, 10) || 0 : 0;
  }
  function refreshFromServer() {
    fetch(routes().cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      setCount(c.item_count, false);
    }).catch(function () {});
  }
  /* επιστροφη στην καρτελα: το καλαθι μπορει να αλλαξε αλλου */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && inflight === 0) { refreshFromServer(); }
  });
  /* οταν το theme ξαναγραφει το εικονιδιο, διαβαζουμε τον αριθμο απο το DOM (τιποτα αλλο) */
  if ('MutationObserver' in window) {
    var w0 = wrap();
    if (w0) {
      new MutationObserver(function () { shownCount = currentCount(); syncFloat(shownCount, false); }).observe(w0, { childList: true, subtree: true, characterData: true });
    }
  }

  /* επιστροφη απο το checkout (#bb-cart): ανοιξε το drawer, καθαρισε το hash */
  if (location.hash === '#bb-cart') {
    try { history.replaceState(null, '', location.pathname + location.search); } catch (x) { /* noop */ }
    setTimeout(openDrawer, 400);
  }

  /* δονηση ΜΟΝΟ στην ΠΡΟΣΘΗΚΗ (Android)
     17/10/2026 AUDIT FIX: αν το theme setting «Vibrate on add to cart» ειναι ενεργο, δονει ΗΔΗ το
     product-form.js (100 ms) — δεν ξαναδονουμε εδω (πριν: 3 δονησεις σε καθε ΠΡΟΣΘΗΚΗ: 20+40+100 ms). */
  var themeBuzzes = !!(window.theme && theme.settings && theme.settings.vibrateOnATC);
  var canBuzz = !themeBuzzes && !!(navigator.vibrate && window.matchMedia && matchMedia('(pointer: coarse)').matches);
  function buzz(ms) { if (!canBuzz) { return; } try { navigator.vibrate(ms || 40); } catch (x) { /* noop */ } }

  /* ---------- «Προστίθεται…»: διχτυ οταν ΔΕΝ ξερουμε το προϊον (quick add) ---------- */
  var addingT = null;
  function hideAdding() {
    clearTimeout(addingT); addingT = null;
    var d = drawer();
    var r = d && d.querySelector('.bb-adding');
    if (r && r.parentNode) { r.parentNode.removeChild(r); }
  }
  function showAdding() {
    var d = drawer();
    if (!d) { return; }
    if (!d.querySelector('.bb-adding')) {
      var row = document.createElement('div');
      row.className = 'bb-adding'; row.setAttribute('role', 'status'); row.setAttribute('aria-live', 'polite');
      row.innerHTML = '<i class="bb-adding-sp" aria-hidden="true"></i><span>Προστίθεται…</span>';
      var hd = d.querySelector('.bb-hd');
      if (hd && hd.parentNode === d) { hd.insertAdjacentElement('afterend', row); } else { d.insertBefore(row, d.firstChild); }
    }
    clearTimeout(addingT); addingT = setTimeout(hideAdding, 8000);
  }

  /* ---------- ghost γραμμη: το προϊον μπαινει στη λιστα ΠΡΙΝ απαντησει ο server ---------- */
  function ghostRowHTML(info, q) {
    var unit = info.price;
    var orig = Math.max(info.orig || 0, unit);
    var img = '';
    if (info.img) {
      var base = info.img.replace(/([?&])width=\d+/, '$1width=180');
      var src = function (w) { return esc(base.replace(/([?&])width=180/, '$1width=' + w)); };
      img = '<a class="block"><img src="' + src(180) + '" srcset="' + src(64) + ' 64w, ' + src(128) + ' 128w, ' + src(180) + ' 180w" sizes="' + esc(info.sizes || '64px') + '" width="54" height="54" alt=""></a>';
    }
    return '<tr class="cart-item bb-ghost grid gap-x-6" data-variant-id="' + esc(info.id) + '" data-bb-unit="' + unit + '" data-bb-orig="' + orig + '">'
      + '<td class="cart-item__image">' + img + '</td>'
      + '<td class="cart-item__details"><span class="cart-item__title m-0 font-bold text-current">' + esc(info.title) + '</span><div class="cart-item__info" data-bb-qty="' + q + '">' + (orig > unit ? '<dl class="m-0"><dd class="price__current inline m-0 font-bold">' + formatMoney(unit) + '</dd><dd class="inline m-0"><span class="price__was line-through">' + formatMoney(orig) + '</span></dd></dl>' : '<strong class="price__current">' + formatMoney(unit) + '</strong>') + '<div class="bb-lp" hidden>' + linePriceHTML(unit, orig, q) + '</div></div></td>'
      + '<td class="cart-item__qty"><div class="flex items-center mt-4"><input type="hidden" class="qty-input__input" value="' + q + '"><span class="cart-item__remove btn btn--icon text-current tap-target" aria-hidden="true">' + TRASH + '</span></div></td></tr>';
  }
  var ghostT = null;
  function clearGhost() {
    clearTimeout(ghostT); ghostT = null;
    var d = drawer();
    if (d) { d.classList.remove('bb-ghosting'); }
  }
  function ghostAdd(d, info, q) {
    var ci = d.querySelector('cart-items');
    if (!ci) { return false; }
    var tbody = ci.querySelector('.cart-items tbody');
    if (!tbody) {
      ci.insertAdjacentHTML('afterbegin', '<table class="cart-items w-full"><tbody></tbody></table>');
      tbody = ci.querySelector('.cart-items tbody');
      if (!tbody) { return false; }
    }
    d.classList.add('bb-ghosting');
    var existing = tbody.querySelector('.cart-item[data-variant-id="' + info.id + '"]:not(.bb-removed)');
    if (existing) {
      var inp = existing.querySelector('.qty-input__input');
      if (inp) { inp.value = (parseInt(inp.value, 10) || 0) + q; }
      paintRow(existing);
    } else {
      tbody.insertAdjacentHTML('beforeend', ghostRowHTML(info, q));
    }
    paintTotals(d, true);
    var c1 = d.querySelector('.bb-ft .bb-c1');
    if (c1) { c1.disabled = true; } /* οχι ΤΑΜΕΙΟ πριν επιβεβαιωσει ο server την προσθηκη */
    var ls = d.querySelector('.bb-ls');
    if (ls) { try { ls.scrollTop = ls.scrollHeight; } catch (x) { /* noop */ } }
    clearTimeout(ghostT); ghostT = setTimeout(function () { clearGhost(); setBusy(-1); refreshDrawer(); }, 10000);
    return true;
  }
  /* τα data-bb-* ζουν στο <product-form> (sections/bb-pdp-main.liquid) */
  function infoFrom(form) {
    if (!form) { return null; }
    var host = form.closest('product-form') || form;
    var idInp = form.querySelector('[name="id"]');
    var price = parseInt(host.getAttribute('data-bb-price'), 10);
    var title = host.getAttribute('data-bb-title');
    if (!idInp || !idInp.value || isNaN(price) || !title) { return null; }
    return {
      id: idInp.value,
      title: title,
      price: price,
      orig: parseInt(host.getAttribute('data-bb-orig'), 10) || price,
      img: host.getAttribute('data-bb-img') || '',
      sizes: host.getAttribute('data-bb-sizes') || ''
    };
  }
  function atcOpensDrawer() {
    try { var st = window.theme && theme.settings; return !(st && st.afterAtc === 'page'); } catch (x) { return true; }
  }

  document.addEventListener('on:cart:error', function (e) {
    hideAdding();
    clearGhost();
    setBusy(-inflight);
    refreshFromServer();
    /* (18) κινητο: το «Προστεθηκε…» δεν ισχυει — το λεμε αμεσως, με το μηνυμα του Shopify αν υπαρχει */
    var et = e && e.target;
    if (et && et.tagName === 'PRODUCT-FORM') { et.__bbQ = null; } /* (19) οσα πατηματα περιμεναν δεν στελνονται */
    if (noDrawer() && et && et.tagName === 'PRODUCT-FORM') {
      var em = e.detail && e.detail.error;
      showToast(typeof em === 'string' && em.trim() ? em.trim() : 'Δεν προστέθηκε. Δοκίμασε ξανά.', true, 3000);
    }
  });

  /* ---------- ΕΝΑΣ ακροατης για τα πατηματα ΠΡΟΣΘΗΚΗ, με φθηνη εξοδο ----------
     ΟΧΙ .js-quick-add: ειναι το «Επιλογη» των καρτων — ανοιγει το quick-add drawer, δεν προσθετει */
  var ATC_SEL = 'button[name="add"],.bb-pdp__cta,[data-bb-sticky-atc],.quick-add-btn,[data-quick-add]';
  var lastAtcTime = 0;
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var tag = t.tagName;
    if (tag !== 'BUTTON' && tag !== 'A' && tag !== 'INPUT' && tag !== 'SPAN' && tag !== 'svg' && tag !== 'path' && tag !== 'IMG' && tag !== 'DIV') { return; }
    var b = t.closest(ATC_SEL);
    if (!b) { return; }
    if (b.closest('#cart-drawer')) { return; } /* κουμπια μεσα στο drawer (σακουλα) εχουν δικη τους ροη */

    var isPdp = b.id === 'bb-pdp-atc' || b.hasAttribute('data-bb-sticky-atc');
    if (!isPdp && (b.disabled || b.getAttribute('aria-disabled') === 'true')) { return; }
    if (!e.isTrusted) { return; }                 /* προγραμματιστικα clicks δεν μετρανε δευτερη φορα */
    if (Date.now() - lastAtcTime < 600) { return; } /* διπλο πατημα = μια προσθηκη */
    if (isPdp && b.disabled) { return; }

    var form = b.closest('form') || document.getElementById('bb-pdp-form');
    var q = 1;
    if (form) { var qi = form.querySelector('input[name="quantity"]'); if (qi) { q = Math.max(1, parseInt(qi.value, 10) || 1); } }
    if (b.hasAttribute('data-bb-sticky-atc')) { q = 1; } /* το sticky ΠΡΟΣΘΗΚΗ βαζει ΠΑΝΤΑ 1 τεμαχιο */

    lastAtcTime = Date.now();
    buzz(40);

    /* (19) Τρεχει ΗΔΗ προσθηκη απο αυτη τη φορμα; Το theme θα αγνοησει αυτο το πατημα
       (product-form.js: aria-disabled στο [name="add"]). Το κραταμε σε ουρα και το στελνουμε
       εμεις μολις τελειωσει η προηγουμενη (runQueued, απο το onThemeAdded). */
    if (isPdp && atcOpensDrawer()) {
      var pf = form && form.closest ? form.closest('product-form') : null;
      var sb = pf ? pf.querySelector('[name="add"]') : null;
      if (pf && sb && sb.getAttribute('aria-disabled') === 'true') {
        if (!pf.__bbQ) { pf.__bbQ = []; }
        pf.__bbQ.push(q);
      }
    }

    /* ΑΜΕΣΩΣ (πριν την απαντηση): το προϊον μεσα στο drawer + ανοιγμα (desktop).
       Το theme (product-form.js) ξαναγραφει το drawer με την απαντηση και ΔΕΝ ξανανοιγει. */
    if (atcOpensDrawer()) {
      var d = drawer();
      var info = infoFrom(form);
      var mob = noDrawer();
      if (!(d && !cpMode(d) && info && ghostAdd(d, info, q)) && !mob) { showAdding(); }
      setBusy(1);
      if (mob) {
        /* (18/20) το καλαθι ΔΕΝ ανοιγει — μηνυμα 1 s· ο αριθμος ανεβαινει στο κουμπι καλαθιου (setCount) */
        /* 17/10/2026 AUDIT FIX: 1000 ms δεν προλαβαινε να διαβαστει — 2500 ms */
        showToast(q === 1 ? 'Προστέθηκε 1 προϊόν στο καλάθι' : 'Προστέθηκαν ' + q + ' προϊόντα στο καλάθι', false, 2500);
      } else {
        openDrawer();
      }
    }

    var next = currentCount() + q;
    afterPaint(function () {
      setCount(next, true);
      var icon = wrap();
      if (icon) {
        replay(icon, 'bb-cart-bump', 'bb-cart-bump2');
        setTimeout(function () { icon.classList.remove('bb-cart-bump'); icon.classList.remove('bb-cart-bump2'); }, 650);
      }
    });
  }, { capture: true });

  /* ---------- ΜΕΤΑ την προσθηκη του theme (product-form.js) ----------
     Στελνει on:cart:add / on:line-item:change απο το <product-form> και ΜΕΤΑ
     (setTimeout 0) κανει renderContents(data) — ολο το drawer ξαναγραφεται με
     την αληθεια, οποτε οι ghost γραμμες φευγουν μονες τους. Εδω: καθαρισμα,
     ανοιγμα αν δεν ανοιξε, focus trap ξανα. */
  var lastThemeAdd = 0;
  /* (19) Στελνει το επομενο πατημα που περιμενε (βλ. click πιο πανω). Τρεχει ΜΕΤΑ το finally του
     product-form.js (το κουμπι δεν ειναι πια aria-disabled) και ΜΕΤΑ το renderContents της
     προηγουμενης απαντησης. true = εφυγε νεα αιτηση. */
  function runQueued(pf) {
    var qu = pf && pf.__bbQ;
    if (!qu || !qu.length) { return false; }
    var f = pf.querySelector('.js-product-form') || pf.querySelector('form');
    var sb = pf.querySelector('[name="add"]');
    if (!f || !sb || sb.disabled || sb.getAttribute('aria-disabled') === 'true' || !pf.isConnected) {
      /* δεν μπορει να σταλει: ξεμετραμε οσα περιμεναν και παιρνουμε την αληθεια απο τον server */
      setBusy(-qu.length); pf.__bbQ = null; refreshFromServer();
      return false;
    }
    var q = qu.shift();
    var pending = q; for (var i = 0; i < qu.length; i++) { pending += qu[i]; }
    var base = currentCount();   /* ο αριθμος που μολις εγραψε ο server στο εικονιδιο */
    /* (20) η αιτηση φευγει με την ποσοτητα του πατηματος που περιμενε (sticky = 1), οχι με ο,τι
       γραφει ΤΩΡΑ το «− 1 +»· το product-form.js διαβαζει τη φορμα συγχρονα μεσα στο submit */
    var qi = f.querySelector('input[name="quantity"]');
    var qOld = qi ? qi.value : null;
    try {
      if (qi) { qi.value = q; }
      if (typeof f.requestSubmit === 'function') { f.requestSubmit(); }
      else { f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
      if (qi) { qi.value = qOld; }
    } catch (x) {
      if (qi) { qi.value = qOld; }
      setBusy(-(qu.length + 1)); pf.__bbQ = null; refreshFromServer();
      return false;
    }
    if (sb.getAttribute('aria-disabled') !== 'true') {
      /* το theme δεν ξεκινησε αιτηση (π.χ. μη εγκυρη φορμα): τιποτα δεν περιμενει πια */
      setBusy(-(qu.length + 1)); pf.__bbQ = null; refreshFromServer();
      return false;
    }
    /* η οθονη ξαναδειχνει αυτο που περιμενει ο πελατης: αριθμος + γραμμη στο drawer */
    setCount(base + pending, false);
    var d = drawer();
    var info = infoFrom(f);
    if (d && info && !cpMode(d)) { ghostAdd(d, info, pending); }
    return true;
  }
  function onThemeAdded(e) {
    var t = e && e.target;
    if (!t || !t.tagName || t.tagName !== 'PRODUCT-FORM') { return; }
    var dup = Date.now() - lastThemeAdd < 300;
    lastThemeAdd = Date.now();
    setTimeout(function () {
      hideAdding();
      clearGhost();
      setBusy(-1);               /* (19) ΚΑΘΕ απαντηση ξεμετραει μια αιτηση */
      if (runQueued(t)) { return; } /* (19) εφυγε το επομενο πατημα: τα υπολοιπα οταν απαντησει κι αυτο */
      if (dup) { return; }
      if (noDrawer()) {
        /* (18) κινητο: το καλαθι δεν ανοιγει μονο του. Αν η προσθηκη εγινε μεσα απο το
           quick-add drawer («Επιλογη» στις καρτες), κλεινει για να φανει η σελιδα + το μηνυμα. */
        var qa = t.closest ? t.closest('quick-add-drawer') : null;
        if (qa && typeof qa.close === 'function') { try { qa.close(); } catch (x) { /* noop */ } }
        return;
      }
      var d = drawer();
      if (!d) { return; }
      if (!d.hasAttribute('open')) { openDrawer(); return; }
      if (typeof trapFocus === 'function') { try { trapFocus(d); } catch (x) { /* noop */ } }
    }, 0);
  }
  document.addEventListener('on:cart:add', onThemeAdded);
  document.addEventListener('on:line-item:change', onThemeAdded);

  /* =========================================================================
     ΠΙΣΩ ΣΤΗΝ ΚΟΡΥΦΗ (μπουρμπουληθρα με βελος)
     ========================================================================= */
  var top = document.createElement('button');
  top.type = 'button'; top.className = 'bb-top'; top.setAttribute('aria-label', 'Πίσω στην κορυφή');
  top.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 14l7-7 7 7"/><path d="M12 7v13" opacity=".55"/></svg>';
  document.body.appendChild(top);
  top.addEventListener('click', function () { try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (x) { window.scrollTo(0, 0); } });

  /* ---------- (18) ΚΙΝΗΤΟ: κουμπι καλαθιου κατω δεξια + μηνυμα «Προστεθηκε…» ----------
     Το κουμπι ειναι ιδιο με το κιτρινο sticker του header (assets/bb-header.css): κυκλος 38px,
     γραμμικη τσαντα, μαυρος αριθμος. Εμφανιση/θεση: assets/bb-cart.css, μπλοκ 18. */
  var fcart = document.createElement('button');
  fcart.type = 'button'; fcart.className = 'bb-fcart'; fcart.setAttribute('aria-label', 'Καλάθι');
  fcart.innerHTML = '<span class="bb-fcart-n" aria-hidden="true"></span>';
  document.body.appendChild(fcart);
  fcart.addEventListener('click', function () {
    try { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: fcart } })); } catch (x) { /* noop */ }
  });
  function syncFloat(n, pop) {
    if (!fcart) { return; }
    n = parseInt(n, 10);
    if (isNaN(n) || n < 0) { n = 0; }
    var num = fcart.firstChild;
    var was = fcart.classList.contains('is-on');
    var txt = n > 0 ? String(n) : '';
    if (num && num.textContent !== txt) {
      num.textContent = txt;
      if (pop && n > 0) { replay(num, 'bb-count-pop', 'bb-count-pop2'); }
    }
    fcart.classList.toggle('is-on', n > 0);
    fcart.setAttribute('aria-label', n > 0 ? ('Καλάθι, ' + n + (n === 1 ? ' προϊόν' : ' προϊόντα')) : 'Καλάθι');
    if (was !== (n > 0)) { placeTop(); }
  }
  var toastEl = null, toastT = null;
  function hideToast() {
    clearTimeout(toastT); toastT = null;
    if (toastEl) { toastEl.classList.remove('is-on'); }
  }
  function showToast(text, isErr, ms) {
    try {
      if (!toastEl || !toastEl.isConnected) {
        toastEl = document.createElement('div');
        toastEl.className = 'bb-toast';
        toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite');
        toastEl.innerHTML = '<i aria-hidden="true"></i><span></span>';
        document.body.appendChild(toastEl);
      }
      toastEl.classList.toggle('bb-toast--err', !!isErr);
      toastEl.lastChild.textContent = text;
      placeTop();
      void toastEl.offsetWidth; /* reflow: να τρεξει το transition και στην πρωτη εμφανιση */
      toastEl.classList.add('is-on');
      clearTimeout(toastT);
      toastT = setTimeout(hideToast, ms || 1000);
    } catch (x) { /* noop */ }
  }

  var topOn = false, ticking = false, lastB = '';
  function placeTop() {
    var st = document.getElementById('bb-pdp-sticky');
    var mob = isMobile();
    var b = mob ? 18 : 28;
    if (st && !st.hidden && mob) {
      var r = st.getBoundingClientRect();
      var h = (window.innerHeight || document.documentElement.clientHeight) - r.top;
      if (h > 0) { b = Math.round(h + 14); }
    }
    /* (18) κινητο: το κουμπι καλαθιου καθεται στη θεση b (ακριβως πανω απο το sticky ΠΡΟΣΘΗΚΗ)
       και το βελακι ανεβαινει απο πανω του (60px κουμπι + 10px κενο — 08/10/2026, ιδια τιμη με το
       body:has(.bb-fcart.is-on) .bb-top στο bb-cart.css). */
    var lift = (fcart && fcart.classList.contains('is-on')) ? 70 : 0;
    var key = b + '|' + lift;
    if (key === lastB) { return; }
    lastB = key;
    var safe = (b === 18 || b === 28);
    var pos = function (px) { return safe ? ('calc(' + px + 'px + env(safe-area-inset-bottom,0px))') : (px + 'px'); };
    top.style.setProperty('--bb-top-bottom', pos(b + lift));
    document.documentElement.style.setProperty('--bb-fc-bottom', pos(b));
  }
  function onScroll() {
    if (ticking) { return; }
    ticking = true;
    requestAnimationFrame(function () {
      var on = (window.scrollY || document.documentElement.scrollTop) > 500;
      if (on !== topOn) { topOn = on; top.classList.toggle('is-on', on); placeTop(); }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', placeTop, { passive: true });
  (function () {
    var st = document.getElementById('bb-pdp-sticky');
    if (st && 'MutationObserver' in window) {
      new MutationObserver(function () { afterPaint(placeTop); }).observe(st, { attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
    }
    window.addEventListener('load', placeTop, { once: true });
    setTimeout(placeTop, 600); setTimeout(placeTop, 1800);
  })();
  placeTop();
  syncFloat(currentCount(), false); /* (18) αριθμος απο το header κατα το φορτωμα της σελιδας */

  /* =========================================================================
     17/10/2026 CP MODE — το συρταρι = η σελιδα /cart (snippets/cart-drawer.liquid, data-bb-cp)
     - cpSync(): μετρητης «N προϊοντα» στο header (χωρις τη σακουλα), κρυψιμο της γραμμης
       «+ Προσθηκη σακουλας» οταν η σακουλα ειναι ηδη μεσα, κρυψιμο μηνυματος/BOX NOW με αδειο καλαθι.
       Τρεχει μετα απο καθε αλλαγη (events του theme) και μετα απο καθε ξαναγραψιμο του DOM.
     - Σακουλα δωρου «+ Προσθηκη» (.bb-cp__af): fetch /cart/add.js και refresh() του <cart-items>
       (ιδια ροη με το script του sections/bb-cart-page.liquid, που ισχυει μονο μεσα στο #bb-cp).
     ========================================================================= */
  function cpSync() {
    var d = drawer();
    if (!d || !cpMode(d)) { return; }
    try {
      var n = 0;
      var infos = d.querySelectorAll('cart-items .cart-item:not([data-variant-id="' + bagId() + '"]) .cart-item__info[data-bb-qty]');
      for (var i = 0; i < infos.length; i++) { n += parseInt(infos[i].getAttribute('data-bb-qty'), 10) || 0; }
      /* μονο οταν αλλαζει κατι — ο MutationObserver πιο κατω ξανακαλει το cpSync σε καθε αλλαγη DOM */
      var sub = d.querySelector('.bb-cpd__sub');
      if (sub) {
        var txt = n > 0 ? (n + (n === 1 ? ' προϊόν' : ' προϊόντα')) : '';
        if (sub.textContent !== txt) { sub.textContent = txt; }
        if (sub.hidden !== (n === 0)) { sub.hidden = n === 0; }
      }
      var bag = d.querySelector('.bb-cp__bag');
      if (bag) {
        var hasBag = !!d.querySelector('cart-items .cart-item[data-variant-id="' + bagId() + '"]');
        if (bag.hidden !== hasBag) { bag.hidden = hasBag; }
      }
      var empty = !d.querySelector('cart-items .cart-item');
      var note = d.querySelector('.bb-cpd__note');
      if (note && note.hidden !== empty) { note.hidden = empty; }
    } catch (x) { /* noop */ }
  }
  var cpSyncT = null;
  function cpSyncSoon() { clearTimeout(cpSyncT); cpSyncT = setTimeout(cpSync, 30); }
  document.addEventListener('on:line-item:change', cpSyncSoon);
  document.addEventListener('on:cart:add', cpSyncSoon);
  document.addEventListener('on:cart-drawer:before-open', cpSyncSoon);
  (function () {
    var d = drawer();
    if (d && cpMode(d) && 'MutationObserver' in window) {
      new MutationObserver(cpSyncSoon).observe(d, { childList: true, subtree: true });
    }
  })();
  cpSync();

  var cpBagBusy = false;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('bb-cp__af')) { return; }
    var d = drawer();
    if (!d || !cpMode(d) || !d.contains(form) || !window.fetch) { return; }
    var endpoint = form.getAttribute('data-bb-endpoint');
    if (!endpoint) { return; }
    e.preventDefault();
    if (cpBagBusy) { return; }
    cpBagBusy = true;
    var btn = form.querySelector('button');
    if (btn) { btn.disabled = true; }
    var idEl = form.querySelector('[name="id"]');
    var qtEl = form.querySelector('[name="quantity"]');
    setBusy(1);
    fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(idEl && idEl.value), quantity: Number(qtEl && qtEl.value) || 1 })
    }).then(function (r) {
      return r.json().then(function () { return r.ok; }, function () { return false; });
    }).then(function (ok) {
      var live = drawer();
      var ci = live && live.querySelector('cart-items');
      if (ok && ci && typeof ci.refresh === 'function' && ci.dataset.empty === 'false') { return Promise.resolve(ci.refresh()); }
      return refreshDrawer(live);
    }).catch(function () {
      return refreshDrawer(drawer());
    }).then(function () {
      setBusy(-1);
      cpBagBusy = false;
      if (btn) { btn.disabled = false; }
      cpSyncSoon();
    });
  });
})();

/* 26/09/2026 — μπουρμπουληθρες σε καθε πατημα (CSS: bb-header.css .bb-taps). 17/10/2026: χωρις δονηση. */
(function () {
  if (window.__bbTaps) { return; }
  window.__bbTaps = true;
  var ATC = 'button[name="add"],.bb-pdp__cta,[data-bb-sticky-atc],.quick-add-btn,[data-quick-add]';
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var canBuzz = !!(navigator.vibrate && window.matchMedia && matchMedia('(pointer: coarse)').matches);
  var layer = null, last = 0;
  function getLayer() {
    if (!layer || !layer.isConnected) {
      layer = document.createElement('div');
      layer.className = 'bb-taps';
      layer.setAttribute('aria-hidden', 'true');
      layer.addEventListener('animationend', function (e) { var t = e.target; if (t && t.parentNode === layer) { layer.removeChild(t); } });
      document.body.appendChild(layer);
    }
    return layer;
  }
  function pop(x, y) {
    var L = getLayer();
    if (L.childElementCount > 40) { return; }
    var frag = document.createDocumentFragment(), n = 6;
    for (var i = 0; i < n; i++) {
      var s = document.createElement('i');
      var a = (Math.PI * 2) * (i / n) + (Math.random() - 0.5) * 0.9;
      var d = 26 + Math.random() * 30, sz = Math.round(10 + Math.random() * 12);
      s.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:' + sz + 'px;height:' + sz + 'px;--dx:' + Math.round(Math.cos(a) * d) + 'px;--dy:' + Math.round(Math.sin(a) * d - 30) + 'px;animation-delay:' + (i * 20) + 'ms';
      frag.appendChild(s);
    }
    L.appendChild(frag);
  }
  document.addEventListener('click', function (e) {
    if (!e.isTrusted) { return; }
    var now = Date.now();
    if (now - last < 60) { return; }
    last = now;
    var t = e.target;
    /* 17/10/2026 AUDIT FIX: ΟΧΙ δονηση σε καθε πατημα της σελιδας (μενου, φωτο, link…) — μονο
       μπουρμπουληθρες. Η δονηση μενει μονο στο ΠΡΟΣΘΗΚΗ (buzz, πιο πανω). */
    if (reduce) { return; }
    var x = e.clientX, y = e.clientY;
    if (!x && !y && t && t.getBoundingClientRect) { var r = t.getBoundingClientRect(); x = r.left + r.width / 2; y = r.top + r.height / 2; }
    /* μετα το paint (rAF + setTimeout 0)· διχτυ 120 ms οταν το rAF δεν τρεχει (κρυφη καρτελα) */
    var done = false;
    function go() { if (done) { return; } done = true; pop(x, y); }
    if (window.requestAnimationFrame) { requestAnimationFrame(function () { setTimeout(go, 0); }); }
    setTimeout(go, 120);
  }, { capture: true, passive: true });
})();

/* ---------- (17) σκια «εχει κι αλλα πιο κατω» στη λιστα του καλαθιου ----------
   Η σκια στο κατω μερος της λιστας (assets/bb-cart.css, .bb-ls--more::after) φαινεται ΜΟΝΟ οταν
   η λιστα σκρολαρει και δεν εχει φτασει στο τελος. Οταν ολα τα προϊοντα χωρανε, καμια σκια:
   προϊοντα + κενο μεχρι τη σακουλα διαβαζονται ως ενα λευκο φοντο. Ανεξαρτητο μπλοκ — αν κατι
   παει στραβα, απλα δεν μπαινει η σκια. */
(function () {
  var pending = false;
  function mark() {
    pending = false;
    try {
      var d = document.getElementById('cart-drawer');
      var ls = d && d.querySelector('.bb-ls');
      if (!ls) { return; }
      var more = !ls.classList.contains('bb-ls--empty') && (ls.scrollHeight - ls.clientHeight - ls.scrollTop) > 6;
      if (ls.classList.contains('bb-ls--more') !== more) { ls.classList.toggle('bb-ls--more', more); }
    } catch (x) { /* noop */ }
  }
  function queue() {
    if (pending) { return; }
    pending = true;
    /* rAF + διχτυ 120 ms οταν το rAF δεν τρεχει (κρυφη καρτελα) */
    if (window.requestAnimationFrame) { requestAnimationFrame(mark); }
    setTimeout(function () { if (pending) { mark(); } }, 120);
  }
  /* το scroll δεν «ανεβαινει» (no bubble) — το πιανουμε στο capture */
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('bb-ls')) { queue(); }
  }, { capture: true, passive: true });
  window.addEventListener('resize', queue, { passive: true });
  document.addEventListener('on:cart-drawer:before-open', function () { queue(); setTimeout(queue, 300); });
  document.addEventListener('on:cart:add', queue);
  document.addEventListener('on:line-item:change', queue);
  function watch() {
    var d = document.getElementById('cart-drawer');
    if (!d || d.__bbMoreObs || !('MutationObserver' in window)) { return; }
    d.__bbMoreObs = true;
    /* childList μονο (οχι attributes): το δικο μας toggle της κλασης δεν ξαναπυροδοτει τον observer */
    new MutationObserver(queue).observe(d, { childList: true, subtree: true });
  }
  watch();
  document.addEventListener('shopify:section:load', function () { watch(); queue(); });
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { watch(); queue(); }, { once: true }); }
  window.addEventListener('load', queue, { once: true });
  queue();
})();
